import React from "react";

const Footer = () => {
	return (
		<div className="footer">
			본페이지는 상업적 목적이 아닌 개인 포트폴리오 용도입니다.
			<br />
			홈페이지의 일부 내용과 이미지 등은 출처가 따로 있음을 밝힙니다.
		</div>
	);
};

export default Footer;
